import { useContext, useMemo } from 'react';
import _ from 'lodash';
import { ProductInfoContext } from '../data/ApplicationDataSource';

export function productListLookup(productList, ref) {
  return useMemo(() => {
    const out = {};

    productList.allLists.names.forEach(name =>
      name.keys.forEach(key => {
        out[name.name + '::' + key.key] = {
          list: key.options,
          index: indexOptions(key.options)
        };
        if (!key.options) {
          console.log(`Warning: List Options ${name.name} with key of ${key.key} has no children options`);
        }
      })
    );
    return out;
  }, [productList])[ref];
}

export function globalListLookup(globalList, ref) {
  const registry = useMemo(() => {
    const out = {};

    const addTo = (obj, key) => {
      if (!obj[key]) {
        obj[key] = {};
      }
    };
    addTo(out, '*');

    for (let gl of globalList) {
      addTo(out, gl.repository);

      addTo(out[gl.repository], gl.package);
      addTo(out['*'], gl.package);

      for (let cd of gl.codeRefs) {
        addTo(out[gl.repository][gl.package], cd.name);
        addTo(out['*'][gl.package], cd.name);

        for (let key of cd.keys) {
          addTo(out[gl.repository][gl.package][cd.name], key.name);
          addTo(out['*'][gl.package][cd.name], key.name);

          const options = {
            list: key.options,
            index: indexOptions(key.options)
          };

          out[gl.repository][gl.package][cd.name][key.name] = options;
          out['*'][gl.package][cd.name][key.name] = options;
        }
      }
    }
    return out;
  }, [globalList]);

  let [key, codeRef, pckg, repo] = ref.split('::').reverse();

  repo = repo || '*';
  pckg = pckg || '*';

  return _.get(registry, [pckg, repo, codeRef, key].join('.'));
}

function indexOptions(options) {
  const index = {};

  if (options) {
    options.forEach(opt => (index[opt.value] = opt.name));
  }

  return index;
}

export function getOptionsForAttr(attr) {
  const { productListConstraint, globalListConstraint } = attr;
  if (!productListConstraint && !globalListConstraint) {
    return null;
  }
  const {
    productSetup: { productList },
    codeRefs
  } = useContext(ProductInfoContext);

  return productListConstraint
    ? productListLookup(productList, productListConstraint)
    : globalListLookup(codeRefs, globalListConstraint);
}
